import { ReactElement, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { useSelector } from "react-redux";
import { IState } from "../../types";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { canRequestFullscreen, exitFullscreen, requestFullscreen } from "../../system/utils";

const FullScreen = (): ReactElement => {
  const dataContext = useSelector((state: IState) => state.dataContext);
  const selected = useSelector((state: IState) => state.selectedNode);
  const [ fullscreen, setFullscreen ] = useState<boolean>(false);

  const processFullScreen = () => {
    if (fullscreen) {
      exitFullscreen();
    } else {
      requestFullscreen();
    }

    setFullscreen(prevState => !prevState);
  };

  return canRequestFullscreen()
    ? <IconButton onClick={processFullScreen} disabled={!dataContext || !selected}>
      <Tooltip title={"Snapshot"}>
        { fullscreen ? <FullscreenExitIcon />: <FullscreenIcon/> }
      </Tooltip>
    </IconButton>
    : <></>;
};

export default FullScreen;
